import { Link } from 'react-router'
import { tools } from '../data/tools'
import { useLanguage } from '../i18n/LanguageContext'
import { useT } from '../i18n/useT'

export default function Tools() {
  const t = useT()
  const { lang } = useLanguage()
  const fr = lang === 'fr'

  return (
    <>
      <section className="bg-gradient-to-b from-brand-50 via-white to-white">
        <div className="mx-auto max-w-7xl px-8 pt-20 pb-16 text-center">
          <h1 className="text-5xl font-extrabold mb-5">{t.tools.h}</h1>
          <p className="text-lg text-ink-mute max-w-2xl mx-auto">{t.tools.sub}</p>
        </div>
      </section>

      <section className="bg-white">
        <div className="mx-auto max-w-7xl px-8 pb-24 grid grid-cols-3 gap-6">
          {tools.map((tool) => (
            <Link
              key={tool.slug}
              to={`/tools/${tool.slug}`}
              className="rounded-2xl border border-slate-100 p-8 flex flex-col hover:border-brand-300 hover:shadow-[0_16px_40px_-16px_rgb(22_163_74/0.2)] transition-all"
            >
              <span className="self-start rounded-full bg-brand-100 text-brand-800 text-xs font-semibold px-3 py-1 mb-5">
                {fr ? tool.tagFr : tool.tag}
              </span>
              <h2 className="text-xl font-bold mb-2.5">{tool.title}</h2>
              <p className="text-[15px] leading-relaxed text-ink-mute mb-6 flex-1">
                {fr ? tool.bodyFr : tool.body}
              </p>
              <span className="inline-flex items-center gap-2 font-semibold text-brand-700">
                {t.tools.openTool}
                <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth={2.2} className="w-4 h-4">
                  <path strokeLinecap="round" strokeLinejoin="round" d="M5 12h14M13 6l6 6-6 6" />
                </svg>
              </span>
            </Link>
          ))}
        </div>
      </section>

      <section className="bg-mist">
        <div className="mx-auto max-w-7xl px-8 py-16 text-center">
          <h2 className="text-3xl font-extrabold mb-4">{t.tools.cta.h}</h2>
          <p className="text-lg text-ink-mute max-w-xl mx-auto mb-8">
            {t.tools.cta.sub}
          </p>
          <Link
            to="/pricing"
            className="inline-block rounded-md bg-brand-600 hover:bg-brand-700 transition-colors text-white font-semibold px-7 py-3.5"
          >
            {t.tools.cta.button}
          </Link>
        </div>
      </section>
    </>
  )
}
